import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Account } from './../../core/interfaces/user.model';
import { AuthService } from './../../core/auth/auth.service';
import { AccountService } from './../../core/services/account.service';
import { PaymentProfile } from 'src/app/core/interfaces/purchase.model';
import { TransactionsService } from 'src/app/core/services/transactions.service';
import Swal from 'sweetalert2';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.css'],
})
export class AccountComponent implements OnInit {
  @Output() resultEvent = new EventEmitter<any>();

  submenuActive = false;
  cargando = false;
  cargandoDatos = true;
  cargandoTarjetas = true;
  cargandoGuardado = false;

  resetPasswordForm: FormGroup;
  datosUserForm: FormGroup;

  verPassword0 = false;
  verPassword1 = false;
  verPassword2 = false;

  mostrarBotonCancelar = false;

  account: Account;
  listaTarjetas: PaymentProfile[] = [];
  tarjetaSeleccionada: PaymentProfile;

  modalTarjetas: any;

  maxLengthBio = 260;

  constructor(
    private router: Router,
    private auth: AuthService,
    private accountService: AccountService,
    private transactionsService: TransactionsService,
  ) {
    this.resetPasswordForm = new FormGroup({
      password0: new FormControl('', Validators.required),
      password1: new FormControl('', [
        Validators.required,
        Validators.pattern(/^(?=.*[A-Za-z])(?=.*\d)([A-Za-z\d]|[^ ]){8,}$/),
        //Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,])[A-Za-z\d@$!%*?&.,]{8,}$/),
      ]),
      password2: new FormControl(''),
    });

    this.resetPasswordForm.controls['password2'].setValidators([
      Validators.required,
      auth.compararPassword.bind(this.resetPasswordForm),
    ]);

    this.datosUserForm = new FormGroup({
      email: new FormControl(null),
      phoneNumber: new FormControl('', [Validators.required, Validators.pattern('^[0-9]{8,9}$')]),
      documentId: new FormControl('', [Validators.required]),
      address: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      zipcode: new FormControl(null, [Validators.required, Validators.pattern('^[0-9]{1,}$')]),
      country: new FormControl('', [Validators.required]),
      firstName: new FormControl('', [Validators.required]),
      lastName: new FormControl('', [Validators.required]),
      bio: new FormControl('', [])
    });
  }

  ngOnInit(): void {
    this.cargandoDatos = true;

    this.modalTarjetas = $('#modalTarjetas');

    this.cargarDatosEnAccount();

    // Obtener datos de la cuenta

    this.cargarTarjetas();
  }

  cargarDatosEnAccount() {

    this.accountService.getAccount().then(
      (res: Account) => {

        if (res) {
          this.account = res;
          this.cargandoDatos = false;
          this.diferenciaEntreFechasParaBotonCancelar(this.account.suscription?.activePeriodStart);

          this.datosUserForm.setValue({
            email: res.email,
            phoneNumber: res.phoneNumber,
            documentId: res.documentId,
            address: res.address,
            city: res.city,
            state: res.state,
            country: res.country,
            zipcode: res.zipCode,
            firstName: res.firstName,
            lastName: res.lastName,
            bio: res.bio || ""
          });
        }

      },
      (error) => {
        this.router.navigateByUrl('/login');
      },
    );

  }

  // Obtener lista de tarjetas
  cargarTarjetas() {
    this.transactionsService.obtenerTarjetasDePago(false).then((resp) => {
      this.cargandoTarjetas = false;
      if (resp) {
        this.listaTarjetas = resp.paymentOptions;
        this.tarjetaSeleccionada = this.listaTarjetas.find((t) => t.isDefaultSuscription);
      }
    });
  }

  diferenciaEntreFechasParaBotonCancelar(dateSent) {
    //5 meses y 1 dia para poder cancelar.
    let currentDate = new Date();
    let dateSentMoment = moment(dateSent).startOf('day');
    let subCancelDate = dateSentMoment.add(5, "M");
    subCancelDate = subCancelDate.add(1, "d");
    let dif = moment(currentDate).startOf('day').diff(subCancelDate, "days");

    if (dif >= 0) {
      this.mostrarBotonCancelar = true;
    }
    else {
      this.mostrarBotonCancelar = false;
    }

  }

  onCancelarSuscripcion() {
    Swal.fire({
      title: 'Esta seguro que quiere cancelar su suscripción?',
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Si',
      denyButtonText: 'No',
      customClass: { popup: 'account_cancelsub' },
    }).then((result) => {
      if (result.isConfirmed) {
        this.cancelarSuscripcion()
        //this.guardarCambios();
      } else if (result.isDenied) {
        //console.log("no");
      }
    })

  }

  cancelarSuscripcion() {
    this.cargandoDatos = true;
    this.accountService.cancelSuscription(this.account.suscription).subscribe((resp) => {
      if (resp === 1) {
        Swal.fire({
          icon: 'success',
          text: "Has cancelado tu suscripcion correctamente.",
          confirmButtonText: 'Ok',
          confirmButtonColor: 'green',
          customClass: { popup: 'account_cancelsub_success' },
        })
        this.cargandoDatos = false;
        this.cargarDatosEnAccount();
        this.resultEvent.emit(resp);
      }
    }, (error) => {
      Swal.fire({
        icon: 'error',
        title: 'UPS!',
        text: `Ha ocurrido un error al cancelar tu suscripcion \nIntente nuevamente en unos minutos.`,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'red'
      })
      this.cargandoDatos = false;
      this.resultEvent.emit(error);
    })
  }

  abrirModalTarjetas() {
    this.modalTarjetas.modal('show');
  }

  onSubmit_Password() {
    if (this.resetPasswordForm.valid) {
      this.cargando = true;

      let email = this.auth.getEmail();

      this.auth.cambioPasswordConsciente({ ...this.resetPasswordForm.value, email }).then((res) => {
        this.cargando = false;
        if (res) {
          this.resetPasswordForm.reset();
        } else {
          this.auth.logout;
          this.router.navigate(['login']);
        }
      });
    }
  }

  onSubmit_DatosPersonales() {
    if (this.datosUserForm.valid) {
      this.cargando = true;

      let email = this.auth.getEmail();

      this.auth.enviarNuevosDatosPersonales({ ...this.datosUserForm.value, email }).then((res) => {
        this.cargando = false;
        if (res) {
          // this.resetPasswordForm.reset();
        } else {
          // this.auth.logout;
          // this.router.navigate(['login']);
        }
      });
    }
  }

  alternarVerPassword(idElement: string = null) {
    if (idElement) {
      let propiedad = 'ver' + idElement.charAt(0).toUpperCase() + idElement.slice(1);

      this[propiedad] = !this[propiedad];
      let elemento: any = document.getElementById(idElement);

      if (elemento) {
        elemento.type = this[propiedad] ? 'text' : 'password';
      }
    }
  }

  submenu_alternar(valor?) {
    if (valor != undefined) {
      this.submenuActive = valor;
    } else {
      this.submenuActive = !this.submenuActive;
    }
  }

  onSeleccionarTarjeta(tarjeta: PaymentProfile) {
    this.cargandoGuardado = true;

    this.transactionsService.actualizarTarjetaSuscripcion(tarjeta).then(
      (resp) => {
        this.cargandoGuardado = false;

        if (resp) {
          Swal.fire({
            icon: 'success',
            title: 'BIEN!',
            html: 'Se ha actualizado la tarjeta seleccinada para la suscripción correctamente.',
            confirmButtonText: 'ACEPTAR',
            customClass: { popup: 'account_cardchange' },
            didClose: () => {
              window.location.reload();
            },
          });
          this.modalTarjetas.modal('hide');
        }
      },
      (err) => {
        this.cargandoGuardado = false;

        Swal.fire({
          icon: 'error',
          title: 'UPS!',
          html: 'Ha ocurrido un error inesperado al momento de actualizar la tarjeta de suscripción. <br> Intente nuevamente en unos minutos.',
          confirmButtonText: 'ACEPTAR',
          didClose: () => { },
        });
      },
    );
  }
}
